module.exports = __webpack_public_path__ + "media/svg-new/spiderweb-a2a0e8f6.svg";